const CommentIcon = ({ color = "#637381" }: { color?: string }) => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_381_34401)">
        <path
          d="M17.4 7.8125H7.72505C7.27505 7.8125 6.86255 8.1875 6.86255 8.675C6.86255 9.1625 7.23755 9.5375 7.72505 9.5375H17.4375C17.8875 9.5375 18.3 9.1625 18.3 8.675C18.3 8.1875 17.8875 7.8125 17.4 7.8125Z"
          fill={color}
        />
        <path
          d="M15.4501 12.3887H7.72505C7.27505 12.3887 6.86255 12.7637 6.86255 13.2512C6.86255 13.7387 7.23755 14.1137 7.72505 14.1137H15.4501C15.9001 14.1137 16.3125 13.7387 16.3125 13.2512C16.3125 12.7637 15.9001 12.3887 15.4501 12.3887Z"
          fill={color}
        />
        <path
          d="M21.7499 3.46289H3.74995C2.47495 3.46289 1.38745 4.51289 1.38745 5.82539V19.9629C1.38745 20.5629 1.72495 21.1254 2.28745 21.3879C2.51245 21.5004 2.73745 21.5379 2.96245 21.5379C3.33745 21.5379 3.67495 21.4254 3.97495 21.1629L7.16245 18.5379H21.7499C23.025 18.5379 24.1124 17.4879 24.1124 16.1754V5.82539C24.1124 4.51289 23.025 3.46289 21.7499 3.46289ZM22.4249 16.1754C22.4249 16.5504 22.1249 16.8504 21.7499 16.8504H6.86245C6.67495 16.8504 6.48745 16.9254 6.33745 17.0379L3.11245 19.7004V5.82539C3.11245 5.45039 3.41245 5.15039 3.78745 5.15039H21.7874C22.1624 5.15039 22.4625 5.45039 22.4625 5.82539V16.1754H22.4249Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_381_34401">
          <rect width="24" height="24" fill="white" transform="translate(0.75 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CommentIcon;
